// extracted by mini-css-extract-plugin
module.exports = {"container":"Kl","copy":"Ll","field":"Ml","error":"Nl","disabled":"Ol","termsContainer":"Pl","termsHeading":"Ql","termsCopy":"Rl","submit":"Sl","srOnly":"Tl"};